import React, { useState } from "react";
import { Container, Paper, Typography, Box, Fade } from "@mui/material";
import { LockOutlined } from "@mui/icons-material";
import MPHomeLoginWithPhoneNumber from "./MPHomeLoginWithPhoneNumber";

export default function MPHomeLoginRequired({
  title = "Please log in to continue",
  subtitle = "Sign in to access this feature",
  onLoginSuccess,
}) {
  const [showLogin, setShowLogin] = useState(false);

  const handleLoginSuccess = () => {
    if (onLoginSuccess) {
      onLoginSuccess();
    }
  };

  return (
    <Container maxWidth="md" sx={{ mt: 8 }}>
      <Fade in={true} timeout={800}>
        <Paper
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 3,
            backgroundColor: "#ffffff",
            border: "1px solid #e5e7eb",
          }}
        >
          {!showLogin ? (
            // Initial State - Prompt to Login
            <Box sx={{ textAlign: "center" }}>
              <Box
                sx={{
                  width: 80,
                  height: 80,
                  borderRadius: "50%",
                  backgroundColor: "#eff6ff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 24px",
                }}
              >
                <LockOutlined sx={{ fontSize: 40, color: "#667eea" }} />
              </Box>

              <Typography
                variant="h5"
                fontWeight="700"
                color="#1a1a1a"
                gutterBottom
              >
                {title}
              </Typography>

              <Typography
                variant="body1"
                color="text.secondary"
                sx={{ mb: 4, maxWidth: 400, mx: "auto" }}
              >
                {subtitle}
              </Typography>

              <button
                onClick={() => setShowLogin(true)}
                style={{
                  padding: "14px 32px",
                  fontSize: "16px",
                  fontWeight: "600",
                  border: "none",
                  borderRadius: "12px",
                  backgroundColor: "#667eea",
                  color: "#fff",
                  cursor: "pointer",
                  boxShadow: "0 4px 12px rgba(102, 126, 234, 0.3)",
                  transition: "all 0.3s ease",
                  outline: "none",
                }}
                onMouseEnter={(e) => {
                  e.target.style.backgroundColor = "#5568d3";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 6px 16px rgba(102, 126, 234, 0.4)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.backgroundColor = "#667eea";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 4px 12px rgba(102, 126, 234, 0.3)";
                }}
              >
                Sign In
              </button>
            </Box>
          ) : (
            // Login Form State
            <Box>
              <Box sx={{ textAlign: "center", mb: 3 }}>
                <Box
                  sx={{
                    width: 60,
                    height: 60,
                    borderRadius: "50%",
                    backgroundColor: "#eff6ff",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "0 auto 16px",
                  }}
                >
                  <LockOutlined sx={{ fontSize: 30, color: "#667eea" }} />
                </Box>
                <Typography variant="h6" fontWeight="600" color="#1a1a1a">
                  Sign In to Your Account
                </Typography>
              </Box>

              <MPHomeLoginWithPhoneNumber onLoginSuccess={handleLoginSuccess} />

              <Box sx={{ textAlign: "center", mt: 3 }}>
                <button
                  onClick={() => setShowLogin(false)}
                  style={{
                    padding: "10px 20px",
                    fontSize: "14px",
                    fontWeight: "600",
                    border: "1px solid #e5e7eb",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    color: "#6b7280",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    outline: "none",
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = "#f9fafb";
                    e.target.style.borderColor = "#d1d5db";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = "#fff";
                    e.target.style.borderColor = "#e5e7eb";
                  }}
                >
                  ← Back
                </button>
              </Box>
            </Box>
          )}
        </Paper>
      </Fade>
    </Container>
  );
}
